import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { FormData } from "../helpers/FormData";
import { _login } from "../services/apiConnections.service";

export const Login = () => {
    // eslint-disable-next-line no-unused-vars
    const [formValues, handleFormValueChange, setFormValues] = FormData({
        email: '',
        password: ''
    });
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        let result = await _login(formValues);
        if (result.error) {
            // Check if result.error is an object containing the specific backend error structure
            if (typeof result.error === 'object' &&
                result.error.hasOwnProperty('error') &&
                typeof result.error.error === 'string') {
                // Extract the message from the nested "error" field, as per backend's 403 response
                setError(result.error.error);
            } else if (typeof result.error === 'string') {
                // Handle cases where result.error is already a string message
                setError(result.error);
            } else {
                // Fallback for unexpected error structures
                setError('An unexpected error occurred during login.');
            }
        } else {
            let token = result.token;
            let user = result.user;
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(user));
            navigate('/users');
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className='loginPageLogo'></div>
            <div className="mb-3">
                <label
                    className='loginLabel'
                    htmlFor='email'>Email</label>
                <input
                    id='email'
                    name='email'
                    type="email"
                    className="loginInput"
                    placeholder="Email"
                    value={formValues.email}
                    onChange={(event) => handleFormValueChange(
                        'email',
                        event.target.value
                    )}
                />
            </div>
            <div className="mb-3">
                <label
                    className='loginLabel'
                    htmlFor='password'>Password</label>
                <input
                    id='password'
                    name='password'
                    type="password"
                    className="loginInput"
                    placeholder="Password"
                    value={formValues.password}
                    onChange={(event) => handleFormValueChange(
                        'password',
                        event.target.value
                    )}
                />
            </div>
            <div className="">
                <button type="submit" className="btn mainBtn loginBtn">Log In</button>
                {error && <p className='msgBlock errorMsg'>{error}</p>}
            </div>
            <p className="loginLinkText">
                <Link className='loginLink' to={'/forgot-password'}>Forgot Your Password?</Link>
            </p>
        </form>
    );
}
